import { TFileId, IDescriptionOfAspectRatio } from 'types';
import { ILoadFromFilePathOptions } from './formImageUploaderState/formImageUploaderContext';
import CropperModal from './components/CropperModal';
import { Uploader } from './components/Uploader';
import ErrorModals from './components/ErrorModals/ErrorModals';
import FormImageUploaderState from './formImageUploaderState/FormImageUploaderState';
import React from 'react';

interface IFormImageUploader {
	setFileId: (fileId: Nullable<string>) => void;
	fileId: TFileId;
	deletePhotoHandler: () => void;
	horizontalAspectRatio?: number;
	verticalAspectRatio?: number;
	descriptionOfAspectRatio?: IDescriptionOfAspectRatio;
	maxWidth?: number;
	maxHeight?: number;
	maxFileSizeMB?: number;
	containerClass?: string;
	noImageIconId?: string;
	loadFromFilePathOptions?: ILoadFromFilePathOptions; // Use for edit forms
	withValidation?: boolean;
	infoContent?: React.ReactNode;
}

const FormImageUploader: React.FC<IFormImageUploader> = ({
	setFileId,
	fileId,
	horizontalAspectRatio,
	verticalAspectRatio,
	descriptionOfAspectRatio,
	maxWidth,
	maxHeight,
	maxFileSizeMB,
	containerClass,
	noImageIconId,
	loadFromFilePathOptions,
	deletePhotoHandler,
	withValidation = false,
	infoContent,
}) => {
	return (
		<FormImageUploaderState setFileId={setFileId}>
			<Uploader
				containerClass={containerClass}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				noImageIconId={noImageIconId}
				withValidation={withValidation}
				deletePhotoHandler={deletePhotoHandler}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
				infoContent={infoContent}
			/>
			<CropperModal
				maxFileSizeMB={maxFileSizeMB}
				loadFromFilePathOptions={loadFromFilePathOptions}
				horizontalAspectRatio={horizontalAspectRatio}
				verticalAspectRatio={verticalAspectRatio}
				maxHeight={maxHeight}
				maxWidth={maxWidth}
				noImageIconId={noImageIconId}
			/>
			<ErrorModals maxFileSizeMB={maxFileSizeMB} />
		</FormImageUploaderState>
	);
};

export default React.memo(FormImageUploader);
